/**
 * Достает число из форматированной цены, в формате 123.44 (или 123, если передана сумма без копеек)
 * @param {string} price Строка с форматированной ценой
 * @return {string}
 */
export var cleanPrice = function cleanPrice(price) {
  var matched = String(price).replace(/\s/g, '').match(/\d+\.?\d*/g);
  return matched ? matched[0] : '';
};